import { defaultPerPageValue } from '../../../constants/PaginationPerPageConstants';
import PublikovanyTerminFilter from '../../../model/PublikovanyTerminFilter';

export default (
  page: number,
  perPage: number,
  sort: Array<string>,
  filter: PublikovanyTerminFilter,
): URLSearchParams => {
  const updatedSearchParams = new URLSearchParams();

  if (filter?.tezaurus?.uuid) {
    updatedSearchParams.set('tezaurus', filter.tezaurus.uuid);
  }

  if (filter.searchTextHladanyTermin) {
    updatedSearchParams.set('hladanyTermin', filter.searchTextHladanyTermin);
  }

  if (filter.searchTextLegalnyZdroj) {
    updatedSearchParams.set('legalnyZdroj', filter.searchTextLegalnyZdroj);
  }

  if (filter.searchTextDoktrinalnyZdroj) {
    updatedSearchParams.set('doktrinalnyZdroj', filter.searchTextDoktrinalnyZdroj);
  }

  if (filter.pouzitiePredpisList && filter.pouzitiePredpisList.length > 0) {
    const pouzitiePredpisList = filter.pouzitiePredpisList
      .map(predpis => predpis.uuid).join(',');
    updatedSearchParams.set('predpisList', pouzitiePredpisList);
  }

  if (page && page !== 1) {
    updatedSearchParams.set('page', page.toString());
  }

  if (perPage && perPage !== defaultPerPageValue) {
    updatedSearchParams.set('perPage', perPage.toString());
  }

  if (sort[0] && sort[1]) {
    if (sort[0] !== 'terminSort'
      || (sort[1] !== 'asc' && sort[1] !== 'desc')) {
      updatedSearchParams.delete('sort');
    } else {
      updatedSearchParams.set('sort', `${sort[0]},${sort[1]}`);
    }
  }
  return updatedSearchParams;
};
